import Class from '@/Class';

type Handler = () => void;

export default class StateNotifier extends Class {
    private handlers: Handler[];

    constructor() {
        super();

        this.isDisposable = true;

        this.handlers = [];
    }

    public onStateReached(handler: Handler) {
        if (this.isDisposed)
            return;

        this.handlers.push(handler);
    }

    public notify() {
        if (this.isDisposed)
            return;

        for (const handler of this.handlers) {
            handler();
        }
    }
}